// Safe storage fallback utility for environments where localStorage/cookies are blocked (e.g. Safari Private Mode / Strict Storage policy)

const memoryStore = {};

export const safeLocalStorage = {
  getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return memoryStore[key] !== undefined ? memoryStore[key] : null;
    }
  },
  setItem(key, value) {
    try {
      window.localStorage.setItem(key, String(value));
    } catch (e) {
      memoryStore[key] = String(value);
    }
  },
  removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      delete memoryStore[key];
    }
  },
  clear() {
    try {
      window.localStorage.clear();
    } catch (e) {
      Object.keys(memoryStore).forEach((k) => delete memoryStore[k]);
    }
  },
  key(index) {
    try {
      return window.localStorage.key(index);
    } catch (e) {
      const keys = Object.keys(memoryStore);
      return keys[index] || null;
    }
  },
  get length() {
    try {
      return window.localStorage.length;
    } catch (e) {
      return Object.keys(memoryStore).length;
    }
  }
};

// Polyfill window.localStorage if accessing it throws a DOMException / SecurityError
(function initSafeStorage() {
  try {
    const testKey = '__storage_test__';
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
  } catch (e) {
    console.warn("window.localStorage is restricted by browser settings. Using in-memory safe fallback.");
    try {
      Object.defineProperty(window, 'localStorage', {
        get: () => safeLocalStorage,
        configurable: true,
        enumerable: true
      });
    } catch (defineErr) {
      console.warn("Unable to redefine window.localStorage property:", defineErr);
    }
  }
})();

export default safeLocalStorage;
